import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store/Store';

import { removeSession } from 'lib/storage';

function useLogout() {
	const dispatch = useDispatch<AppDispatch>();

	const logout = useCallback(() => {
		dispatch({ type: 'logout' });
		removeSession();
	}, [dispatch]);

	return logout;
}

export default useLogout;
